import React, { useState } from 'react';
import { Bell, ChevronLeft, Star, Heart, ShoppingCart, X, Plus, Minus } from 'lucide-react';

const products = [
  {
    id: 1,
    name: 'SmartFit Pro',
    description: 'Montre connectée haute précision avec monitoring avancé',
    price: '50$',
    imageUrl: '/api/placeholder/400/300',
    details: 'Surveillance cardiaque 24/7, GPS intégré, autonomie de 7 jours',
    specs: ['Étanche 50m', 'Bluetooth 5.0', 'Écran AMOLED']
  },
  {
    id: 2,
    name: 'SmartFit Pro',
    description: 'Montre connectée haute précision avec monitoring avancé',
    price: '50$',
    imageUrl: '/api/placeholder/400/300',
    details: 'Surveillance cardiaque 24/7, GPS intégré, autonomie de 7 jours', 
    specs: ['Étanche 50m', 'Bluetooth 5.0', 'Écran AMOLED']
  },
];

const Modal = ({ children, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
        {children}
      </div>
    </div>
  );
};

const ProductCard = ({ product, onClick }) => (
  <div 
    onClick={onClick}
    className="group bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer overflow-hidden"
  >
    <div className="relative">
      <img
        src={product.imageUrl}
        alt={product.name}
        className="w-full h-72 object-cover transform transition-transform group-hover:scale-105"
      />
      <button 
        onClick={(e) => e.stopPropagation()}
        className="absolute top-4 right-4 p-2 bg-white/80 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
      >
        <Heart className="w-5 h-5 text-gray-600 hover:text-red-500 transition-colors" />
      </button>
    </div>
    <div className="p-6">
      <div className="flex justify-between items-start mb-3">
        <div>
          <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">
            {product.name}
          </h3>
          <p className="text-gray-600 text-sm line-clamp-2">{product.description}</p>
        </div>
        <span className="text-2xl font-bold text-blue-600">{product.price}</span>
      </div>
      <div className="flex justify-between items-center">
        <div className="flex gap-1">
          {[...Array(5)].map((_, index) => (
            <Star
              key={index}
              className={`w-4 h-4 ${index === 0 ? 'fill-blue-600 text-blue-600' : 'text-gray-300'}`}
            />
          ))}
        </div>
        <button 
          onClick={(e) => e.stopPropagation()} 
          className="p-2 bg-blue-600 text-white rounded-full opacity-0 group-hover:opacity-100 transition-all transform translate-y-2 group-hover:translate-y-0"
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
    </div>
  </div>
);

const ProductDetails = ({ product, quantity, setQuantity }) => (
  <div className="p-6">
    <h2 className="text-2xl font-bold mb-6">{product.name}</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="relative group">
        <img
          src={product.imageUrl}
          alt={product.name}
          className="w-full h-[300px] object-cover rounded-lg"
        />
        <button className="absolute top-4 right-4 p-2 bg-white/80 backdrop-blur-sm rounded-full">
          <Heart className="w-5 h-5 text-gray-600 hover:text-red-500 transition-colors" />
        </button>
      </div>
      
      <div className="space-y-4">
        <p className="text-gray-600">{product.details}</p>
        
        <div className="space-y-2">
          <h4 className="font-semibold">Caractéristiques :</h4>
          <ul className="space-y-1">
            {product.specs.map((spec, index) => (
              <li key={index} className="text-gray-600 flex items-center gap-2">
                <span className="w-1 h-1 bg-blue-600 rounded-full"></span>
                {spec}
              </li>
            ))}
          </ul>
        </div>

        <div className="flex items-center gap-4">
          <div className="flex items-center border rounded-lg">
            <button 
              onClick={() => setQuantity(Math.max(1, quantity - 1))}
              className="p-2 hover:bg-gray-100"
            >
              <Minus className="w-4 h-4" />
            </button>
            <span className="px-4 font-medium">{quantity}</span>
            <button 
              onClick={() => setQuantity(quantity + 1)}
              className="p-2 hover:bg-gray-100"
            >
              <Plus className="w-4 h-4" />
            </button>
          </div>
          <span className="text-2xl font-bold text-blue-600">
            {product.price}
          </span>
        </div>

        <button className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors">
          Ajouter au panier
        </button>
      </div>
    </div>
  </div>
);

const ListeProduit = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
    setQuantity(1);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="sticky top-0 z-40 bg-white/80 backdrop-blur-sm border-b">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between px-4 py-4">
            <div className="flex items-center gap-3">
              <button className="p-2 hover:bg-gray-100 rounded-full transition-colors">
                <ChevronLeft className="w-6 h-6 text-blue-600" />
              </button>
              <h1 className="text-2xl font-bold text-blue-600">Kappela Vendeur</h1>
            </div>
            <div className="flex items-center gap-4">
              <button className="p-2 hover:bg-gray-100 rounded-full transition-colors relative">
                <ShoppingCart className="w-6 h-6 text-gray-600" />
                <span className="absolute -top-1 -right-1 bg-blue-600 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
                  {quantity}
                </span>
              </button>
              <button className="p-2 hover:bg-gray-100 rounded-full transition-colors">
                <Bell className="w-6 h-6 text-gray-600" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="mb-8">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">Produits</h2>
          <p className="text-gray-600 text-lg">
            Achetez des produits via Telegram, sans aucune redirection. Simple, rapide et sécurisé !
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} onClick={() => openModal(product)} />
          ))}
        </div>
      </div>

      <Modal isOpen={isModalOpen} onClose={closeModal}>
        {selectedProduct && (
          <ProductDetails 
            product={selectedProduct} 
            quantity={quantity} 
            setQuantity={setQuantity}
          />
        )}
      </Modal>
    </div>
  );
};

export default ListeProduit;